module.exports = __webpack_public_path__ + "static/e97981c0aab6352365f20db93c2c9f9da25f400171b3bc1d82794f5b60b7d768-aecd38e2141d1d13d85075de9630250c.jpeg";